export default "__VITE_PUBLIC_ASSET__d264f51a__"